import {
	ORDER_SITUATION,
	POST_PAYMENT_MESSAGES,
} from '../../../../../constants/post-payment.constants'

export const NO_TICKETS_KIND = {
	AWAITING_PIX: 'awaiting-pix',
	IN_PROGRESS: 'in-progress',
	UNDER_REVIEW: 'under-review',
	FAILED: 'failed',
}

/**
 * Spec 056 (US6) — o que dizer quando o pedido aberto em Minhas Compras nao tem
 * bilhete.
 *
 * Ate aqui havia so dois textos: "aguardando pagamento" (Pix) e, para todo o
 * resto, "algo deu errado, a compra nao sera cobrada". Essa segunda frase era o
 * rosto do bug 8005 dentro de Minhas Compras: o pedido ainda estava EMITINDO,
 * ou estava retido com o dinheiro do cliente, e a tela afirmava que nao havia
 * cobranca. Agora cada situacao tem a sua.
 *
 * @param {string} orderStatus Situacao vinda do Hub (ClientOrderSituation)
 * @return {{kind: string, lines: string[]}} tipo + linhas de texto
 */
export function resolveNoTicketsMessage(orderStatus) {
	if (orderStatus === 'Pendente')
		return {
			kind: NO_TICKETS_KIND.AWAITING_PIX,
			lines: [
				'Este pedido ainda está aguardando a confirmação do pagamento.',
				'Utilize o botão "Ver QR Code do Pix" acima para efetuar o pagamento.',
			],
		}

	if (orderStatus === ORDER_SITUATION.IN_PROGRESS)
		return {
			kind: NO_TICKETS_KIND.IN_PROGRESS,
			lines: [POST_PAYMENT_MESSAGES.NO_TICKETS_IN_PROGRESS],
		}

	if (orderStatus === ORDER_SITUATION.UNDER_REVIEW)
		return {
			kind: NO_TICKETS_KIND.UNDER_REVIEW,
			lines: [POST_PAYMENT_MESSAGES.NO_TICKETS_UNDER_REVIEW],
		}

	// Cancelado / desconhecido: o pedido nao rendeu bilhete. NAO afirma nada
	// sobre cobranca - se houve estorno, ele aparece no proprio pedido, e dizer
	// "nao sera cobrada" sobre uma compra cobrada foi o erro que esta spec corrige.
	return {
		kind: NO_TICKETS_KIND.FAILED,
		lines: ['Este pedido não gerou bilhetes.'],
	}
}
